// TODO discuss what additional events we want to track,
// and what payload should we pass down
// Refs: https://github.com/tes/resources/issues/6205

const getMz = () => window._mz;

/**
 * get metadata provided by mz
 */
export const getMetadata = () => {
  const metadata = {};
  const mz = getMz();
  if (mz) {
    const { pageMetadata, userMetadata } = mz;
    metadata.mz = { pageMetadata, userMetadata };
  } else {
    console.log('MML: could not find mz!');
  }
  // add additional data if needed
  return metadata;
};

const trackEvent = (eventName, campaignId, props = {}) => {
  const mz = getMz();
  const { payload = {}, ...otherProps } = props;

  if (mz) {
    mz.emit(mz.events[eventName], {
      module: {
        type: 'marketing-banners',
        name: campaignId
      },
      payload,
      ...otherProps
    });
  } else {
    console.log(`MML: Tried to track ${eventName}, but couldn't find mz!`);
  }
};

export const trackDisplay = trackEvent.bind(null, 'DISPLAY');
export const trackClose = trackEvent.bind(null, 'CLOSE');
export const trackAccept = trackEvent.bind(null, 'ACCEPT');
export const trackSubmit = trackEvent.bind(null, 'SUBMIT');
export const trackClick = trackEvent.bind(null, 'CLICK');
